// extracted by mini-css-extract-plugin
export default {"collapsible":"collapsible_collapsible__UjFOY","collapsed":"collapsible_collapsed__xUrNR"};